export const eventsConfig = {
  cities: [
    {
      slug: "london",
      name: "London",
      intro: "London is one of the world's leading business event hubs, hosting major conferences, trade shows and exhibitions all year round.",
      venues: [
        {
          slug: "excel-london",
          name: "ExCeL London",
          intro: "ExCeL London is a world-class exhibition and convention centre in the Royal Docks, ideal for large-scale conferences and trade shows.",
          events: [
            {
              eventSlug: "the-business-show-london-2026",
              name: "The Business Show London 2026",
              city: "London",
              venueName: "ExCeL London",
              dates: {
                start: "2026-11-11",
                end: "2026-11-12",
                display: "11–12 November 2026",
              },
              organiserName: "The Business Show",
              organiserWebsite: "https://www.greatbritishbusinessshow.co.uk/",
              officialUrl: "https://www.greatbritishbusinessshow.co.uk/",
              shortDescription: "The Business Show London brings together thousands of entrepreneurs, SMEs and decision-makers for two days of networking, seminars and business growth insights.",
              longDescription: "The Business Show London 2026 is one of Europe's largest events for growing businesses, featuring keynote speakers, workshops, exhibitors and networking opportunities. It attracts founders, directors and senior decision-makers from across the UK and beyond who are looking for new ideas, partners and suppliers. If you're bringing a team, sponsors or clients to the show, organising group accommodation and meeting space early is essential.",
              sectorTags: ["Business", "SME", "Entrepreneurship", "Networking"],
            },
            {
              eventSlug: "tech-show-london-2026",
              name: "Tech Show London 2026",
              city: "London",
              venueName: "ExCeL London",
              dates: {
                start: "2026-03-04",
                end: "2026-03-05",
                display: "4–5 March 2026",
              },
              organiserName: "Tech Show Events",
              organiserWebsite: "https://www.techshowlondon.co.uk/",
              officialUrl: "https://www.techshowlondon.co.uk/",
              shortDescription: "Tech Show London 2026 is the UK's premier technology exhibition featuring the latest in cloud, cybersecurity, AI and digital transformation solutions.",
              longDescription: "Tech Show London brings together IT decision-makers, tech vendors and innovators for two days of product demos, expert talks and networking. Covering cloud infrastructure, cybersecurity, AI/ML, IoT and enterprise software, it's essential for teams evaluating new technology investments. If you're attending with colleagues, sponsors or clients, we can arrange convenient group accommodation and private meeting spaces near ExCeL – completely free of charge.",
              sectorTags: ["Technology", "Cloud", "Cybersecurity", "AI"],
            },
            {
              eventSlug: "hrc-hotel-restaurant-catering-2026",
              name: "HRC – Hotel, Restaurant & Catering 2026",
              city: "London",
              venueName: "ExCeL London",
              dates: {
                start: "2026-03-30",
                end: "2026-04-01",
                display: "30 March – 1 April 2026",
              },
              organiserName: "Hospitality Events UK",
              organiserWebsite: "https://www.hrc.co.uk/",
              officialUrl: "https://www.hrc.co.uk/",
              shortDescription: "HRC is the UK's leading hospitality trade show, connecting hotel operators, restaurateurs and catering professionals with suppliers and technology providers.",
              longDescription: "HRC 2026 brings the hospitality industry together for three days of innovation, inspiration and business development. From kitchen equipment to booking systems, sustainable practices to guest experience tech, HRC showcases the products and services that drive modern hospitality businesses. Ideal for hotel groups, restaurant chains and catering companies bringing teams to discover new suppliers. We provide complimentary group accommodation booking and meeting room coordination for all attending organisations.",
              sectorTags: ["Hospitality", "Foodservice", "Hotels", "B2B"],
            },
            {
              eventSlug: "international-confex-2026",
              name: "International Confex 2026",
              city: "London",
              venueName: "ExCeL London",
              dates: {
                start: "2026-03-03",
                end: "2026-03-04",
                display: "3–4 March 2026",
              },
              organiserName: "Confex Events",
              organiserWebsite: "https://www.international-confex.com/",
              officialUrl: "https://www.international-confex.com/",
              shortDescription: "International Confex is the UK's leading event for meetings, events and incentive travel professionals to discover venues, suppliers and inspiration.",
              longDescription: "International Confex 2026 connects event planners, corporate travel buyers and agency professionals with venues, destinations and suppliers from around the world. Whether you're sourcing conference locations, team-building activities or incentive travel packages, Confex offers face-to-face meetings with hundreds of exhibitors plus educational seminars on industry trends. If you're bringing a team from your agency or corporate events department, we'll arrange convenient group hotels and meeting rooms near ExCeL at no cost.",
              sectorTags: ["Events Industry", "Meetings", "MICE", "Corporate Travel"],
            },
            {
              eventSlug: "test-past-event-london-2024",
              name: "TEST: London Business Expo 2024 (PAST EVENT FOR TESTING)",
              city: "London",
              venueName: "ExCeL London",
              dates: {
                start: "2024-06-10",
                end: "2024-06-12",
                display: "10–12 June 2024",
              },
              organiserName: "Test Events Ltd",
              organiserWebsite: "https://example.com",
              officialUrl: "https://example.com/test-event",
              shortDescription: "THIS IS A TEST EVENT WITH A PAST DATE - Used to demonstrate the past event banner and filtering functionality.",
              longDescription: "This is a test event specifically created with a past end date (June 2024) to allow testing of the evergreen events system. When you visit this page, you should see an amber 'This event has now ended' banner at the top. This event should also NOT appear in the default 'upcoming events' listings on city and venue pages, but should be visible when you click 'View Past Events'. This demonstrates how the Events Hub automatically handles events that have finished.",
              sectorTags: ["Test", "Demo", "Past Event"],
            },
          ],
        },
      ],
    },
    {
      slug: "birmingham",
      name: "Birmingham",
      intro: "Birmingham's central UK location and world-class NEC venue make it ideal for major trade shows, exhibitions and national conferences.",
      venues: [
        {
          slug: "nec-birmingham",
          name: "NEC Birmingham",
          intro: "The National Exhibition Centre is the UK's largest dedicated exhibition space, hosting some of Britain's biggest trade shows and consumer events.",
          events: [
            {
              eventSlug: "spring-fair-2026",
              name: "Spring Fair 2026",
              city: "Birmingham",
              venueName: "NEC Birmingham",
              dates: {
                start: "2026-02-01",
                end: "2026-02-05",
                display: "1–5 February 2026",
              },
              organiserName: "Spring Fair Events",
              organiserWebsite: "https://www.springfair.com/",
              officialUrl: "https://www.springfair.com/",
              shortDescription: "Spring Fair is the UK's leading trade show for gift, home and fashion buyers, bringing together thousands of retailers and brands over five days.",
              longDescription: "Spring Fair 2026 at the NEC is where the UK retail industry comes to discover new products, place orders and build supplier relationships. Covering gifts, homewares, fashion accessories, jewellery, greeting cards and more, it attracts buyers from independent shops, department stores and major retail chains. If you're exhibiting or buying with a team, arranging group accommodation near the NEC in advance is essential. We provide complimentary hotel booking and meeting space coordination for all Spring Fair attendees.",
              sectorTags: ["Retail", "Gift", "Homewares", "Trade Show"],
            },
            {
              eventSlug: "crufts-2026",
              name: "Crufts 2026",
              city: "Birmingham",
              venueName: "NEC Birmingham",
              dates: {
                start: "2026-03-05",
                end: "2026-03-08",
                display: "5–8 March 2026",
              },
              organiserName: "The Kennel Club",
              organiserWebsite: "https://www.crufts.org.uk/",
              officialUrl: "https://www.crufts.org.uk/",
              shortDescription: "Crufts is the world's largest dog show, attracting exhibitors, breeders, handlers and dog lovers from over 40 countries.",
              longDescription: "Crufts 2026 brings together the global dog community for four days of competitions, displays, shopping and networking at the NEC. Whether you're competing, exhibiting pet products or attending as trade visitors, Crufts requires significant accommodation for teams, handlers and support staff. Hotels near the NEC fill up fast – we can secure group bookings and meeting rooms for your delegation completely free of charge. Perfect for breed clubs, pet brands and international visitors needing coordinated accommodation.",
              sectorTags: ["Pets", "Exhibition", "International", "Competition"],
            },
            {
              eventSlug: "autumn-fair-2026",
              name: "Autumn Fair 2026",
              city: "Birmingham",
              venueName: "NEC Birmingham",
              dates: {
                start: "2026-09-06",
                end: "2026-09-09",
                display: "6–9 September 2026",
              },
              organiserName: "Autumn Fair Events",
              organiserWebsite: "https://www.autumnfair.com/",
              officialUrl: "https://www.autumnfair.com/",
              shortDescription: "Autumn Fair is the UK's leading gift, home and fashion trade show, where retailers discover products and trends for the Christmas season and beyond.",
              longDescription: "Autumn Fair 2026 at the NEC is the essential destination for UK retailers preparing for peak trading season. With thousands of exhibitors showcasing gifts, homewares, fashion, jewellery, festive products and more, it's where independent shops and major chains place orders and build supplier partnerships. If you're attending with buying teams or exhibiting with sales staff, coordinating group accommodation near the NEC is critical. We provide free hotel booking and meeting room services for all Autumn Fair visitors.",
              sectorTags: ["Retail", "Gift", "Fashion", "Trade Show"],
            },
            {
              eventSlug: "uk-construction-week-2026",
              name: "UK Construction Week 2026",
              city: "Birmingham",
              venueName: "NEC Birmingham",
              dates: {
                start: "2026-10-05",
                end: "2026-10-07",
                display: "5–7 October 2026",
              },
              organiserName: "UK Construction Events",
              organiserWebsite: "https://www.ukconstructionweek.com/",
              officialUrl: "https://www.ukconstructionweek.com/",
              shortDescription: "UK Construction Week is Britain's largest trade event for construction professionals, featuring 600+ exhibitors and covering every aspect of the built environment.",
              longDescription: "UK Construction Week 2026 brings together contractors, architects, engineers, property developers and suppliers for three days of innovation, networking and industry insights. Covering sustainable building, modular construction, offsite manufacturing, BIM, safety and more, it's essential for construction firms evaluating new products and methods. If you're sending project teams, technical staff or senior management, we can arrange convenient group hotels and private meeting spaces near the NEC – completely free of charge.",
              sectorTags: ["Construction", "Architecture", "Engineering", "Property"],
            },
          ],
        },
      ],
    },
    {
      slug: "manchester",
      name: "Manchester",
      intro: "Manchester is the North's leading business events destination, with world-class venues hosting major conferences, tech events and exhibitions.",
      venues: [
        {
          slug: "manchester-central",
          name: "Manchester Central",
          intro: "Manchester Central is a landmark convention centre in the heart of the city, offering exceptional facilities for conferences and exhibitions.",
          events: [
            {
              eventSlug: "manchester-tech-week-2026",
              name: "Manchester Tech Week – DTX + UCX 2026",
              city: "Manchester",
              venueName: "Manchester Central",
              dates: {
                start: "2026-04-29",
                end: "2026-04-30",
                display: "29–30 April 2026",
              },
              organiserName: "Manchester Tech Events",
              organiserWebsite: "https://www.dtxevents.io/",
              officialUrl: "https://www.dtxevents.io/manchester-tech-week",
              shortDescription: "Manchester Tech Week combines Digital Transformation Expo (DTX) and Unified Communications Expo (UCX) for two days of technology innovation and networking.",
              longDescription: "Manchester Tech Week 2026 brings together IT leaders, digital transformation specialists and communications technology professionals for the North's premier tech event. DTX focuses on cloud, AI, cybersecurity and enterprise software, while UCX covers collaboration tools, contact centres and business communications. Ideal for corporate IT teams, tech vendors and consultancies exploring new solutions. If you're attending with colleagues or clients, we provide complimentary group accommodation booking and meeting room coordination near Manchester Central.",
              sectorTags: ["Technology", "Digital Transformation", "Cloud", "Communications"],
            },
            {
              eventSlug: "northern-health-innovation-summit-2026",
              name: "Northern Health Innovation Summit 2026",
              city: "Manchester",
              venueName: "Manchester Central",
              dates: {
                start: "2026-06-10",
                end: "2026-06-11",
                display: "10–11 June 2026",
              },
              organiserName: "NHS Innovation Events",
              organiserWebsite: "https://www.healthinnovationsummit.co.uk/",
              officialUrl: "https://www.healthinnovationsummit.co.uk/",
              shortDescription: "The Northern Health Innovation Summit brings together NHS leaders, healthcare tech providers and medical professionals to explore digital health solutions and clinical innovation.",
              longDescription: "The Northern Health Innovation Summit 2026 connects NHS trusts, private healthcare providers, medical technology companies and digital health innovators for two days of collaboration and knowledge sharing. Topics include electronic patient records, AI diagnostics, remote monitoring, staff wellbeing and integrated care systems. Perfect for clinical teams, IT directors and healthcare suppliers evaluating new technologies. We offer complimentary group accommodation booking and meeting room services for all NHS and healthcare delegations attending the summit.",
              sectorTags: ["Healthcare", "NHS", "Digital Health", "Medical Technology"],
            },
          ],
        },
      ],
    },
  ],
};
